"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuDto = void 0;
var MenuDto = /** @class */ (function () {
    function MenuDto(_a) {
        var name = _a.name, areaIds = _a.areaIds, active = _a.active, activePeriods = _a.activePeriods, sections = _a.sections, config = _a.config, menuType = _a.menuType, image = _a.image, description = _a.description, emailMessage = _a.emailMessage, orderDestinationId = _a.orderDestinationId, eventDetails = _a.eventDetails, ticketDetails = _a.ticketDetails, depositPerItem = _a.depositPerItem, defaultItemFee = _a.defaultItemFee, maxTotalItemFee = _a.maxTotalItemFee, stripeAccountId = _a.stripeAccountId, customDataFields = _a.customDataFields;
        this.name = name;
        this.areaIds = areaIds;
        this.active = active;
        this.activePeriods = activePeriods;
        this.sections = sections;
        this.config = config;
        this.menuType = menuType;
        this.image = image;
        this.description = description;
        this.emailMessage = emailMessage;
        this.orderDestinationId = orderDestinationId;
        this.eventDetails = eventDetails;
        this.ticketDetails = ticketDetails;
        this.depositPerItem = depositPerItem;
        this.defaultItemFee = defaultItemFee;
        this.maxTotalItemFee = maxTotalItemFee;
        this.stripeAccountId = stripeAccountId;
        this.customDataFields = customDataFields;
    }
    return MenuDto;
}());
exports.MenuDto = MenuDto;
